import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';
import StyleOneSectionTitle from './StyleOneSectionTitle'

export class StyleOneCommonProblem extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
  }

  render() {
    let { itemsData } = this.props;

    return (
      <div className="topic-style-one-common-problem" style={{ background: `url(${itemsData.totalbackImg}) no-repeat`}}>
        <div className='common_problem_container'>
          <a name={itemsData.name}><StyleOneSectionTitle Data={itemsData} isColorW={true} /></a>
          <div className='common_problem_list'>
            {itemsData.list && itemsData.list.map(item => <div className='common_problem_item' key={item.id}>
              <div className='common_problem_item_title flex_row'>
                <div className='common_problem_rank flex_row'>{item.id}</div>
                <div>{item.title}</div>
              </div>
              <div className='common_problem_item_content'>
                {item.contentList && item.contentList.map(_item => <div dangerouslySetInnerHTML={{ __html: _item.content }} key={_item.id}></div>)}
              </div>
            </div>)}
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleOneCommonProblem);



// WEBPACK FOOTER //
// ./src/features/style-one/StyleOneCommonProblem.js